import mainApiClient from '../interceptor.mainApiClient';

const mlRiskScoreEndpoints = {
  getScore: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/ml-risk-score`, config),

  getHistory: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/ml-risk-score/history`, config),

  getFactors: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/ml-risk-score/factors`, config),
};

export default mlRiskScoreEndpoints;
